export default __webpack_public_path__ + "b27f6fd8ce2b45e75e1468fdfc703f78.png";